
import { getApiImageUrl } from './helpers';

const countryImages = {
    "United Kingdom": getApiImageUrl('country', 'United Kingdom.webp'),
    "Denmark": getApiImageUrl('country', 'Denmark.webp'),
    "Netherlands": getApiImageUrl('country', 'Netherlands.webp'),
    "Sweden": getApiImageUrl('country', 'Sweden.webp'),
    "Germany": getApiImageUrl('country', 'Germany.webp'),
    "France": getApiImageUrl('country', 'France.webp'),
    "Belgium": getApiImageUrl('country', 'Belgium.webp'),
    "Finland": getApiImageUrl('country', 'Finland.webp'),
    "Norway": getApiImageUrl('country', 'Norway.webp'),
    "Switzerland": getApiImageUrl('country', 'Switzerland.webp'),
    "Luxembourg": getApiImageUrl('country', 'Luxembourg.webp'),
};

export { countryImages };

